import cameraIcon from "../../assets/icons/camera-icon.svg";
import chatIcon from "../../assets/icons/chat.svg";
import expandIcon from "../../assets/icons/expand.svg";
import arrowIcon from "../../assets/icons/arrow.svg";
import hamburguerIcon from "../../assets/icons/menu-hamburguer.svg";


export type TourPlacement = "top" | "bottom" | "left" | "right" | "center" | "right-top";

export type TourContentPart =
  | { type: "text"; value: string }
  | { type: "icon"; src: string; alt: string };

export interface TourStep {
   id: string;
  target: string;
  placement?: TourPlacement;
  content: TourContentPart[];
  glosa: string;
  offsetY?: number;
  offsetX?: number;
}

const text = (value: string): TourContentPart => ({ type: "text", value });
const icon = (src: string, alt: string): TourContentPart => ({ type: "icon", src, alt });


export const tourSteps: TourStep[] = [
  {
    id: "welcome-1",
    target: "",
    placement: "center",
    content: [
      text(
        "Olá! Eu sou a Lisa, uma inteligência artificial criada para tornar a sua experiência mais acessível."
      ),
    ],
    glosa: "CLIQUE COMECAR CONVERSAR",
  },
  {
    id: "welcome-2",
    target: "",
    placement: "center",
    content: [
      text(
        "Mais do que uma assistente virtual, estou aqui para responder às suas dúvidas, encontrar informações e " +
          "traduzir conteúdos para a Libras, tornando a comunicação mais simples, prática e inclusiva."
      ),
    ],
    glosa: "CLIQUE COMECAR CONVERSAR",
  },
  {
    id: "start-camera",
    target: "camera-button",
    placement: "right",
    content: [
      text("Clique no botão"),
      icon(cameraIcon, "iniciar conversa em video"),
      text("para iniciar a conversa em Libras."),
    ],
    glosa: "CLIQUE COMECAR CONVERSAR",
  },
  {
    id: "start-chat",
    target: "chat-button",
    placement: "left",
    content: [
      text("Clique no botão"),
      icon(chatIcon, "abrir chat"),
      text("para iniciar a conversa em português."),
    ],
    glosa: "CLIQUE COMECAR CONVERSAR",
    offsetY: -30,
  },
  {
    id: "control-chat-expand",
    target: "expand-icon",
    placement: "left",
    content: [
      text("Clique no ícone de expansão"),
      icon(expandIcon, "expandir chat"),
      text("para ampliar o Chat."),
    ],
    glosa: "CLIQUE COMECAR CONVERSAR",
  },
  {
    id: "expand-chat",
    target: "expand-chat",
    placement: "left",
    content: [
      text("Nesse modo, a janela ocupará metade da tela."),
    ],
    glosa: "CLIQUE COMECAR CONVERSAR",
  },
  {
    id: "control-chat-minimize",
    target: "minimize-button",
    placement: "left",
    content: [
      text("Para minimizá-la, clique no ícone de seta"),
      icon(arrowIcon, "minimizar chat"),
      text("."),
    ],
    glosa: "CLIQUE COMECAR CONVERSAR",
  },
  {
    id: "chat-input",
    target: "chat-input",
    placement: "top",
    content: [
      text("No chat, você pode escrever o texto em português nesse campo."),
    ],
    glosa: "CLIQUE COMECAR CONVERSAR",
  },
  {
    id: "chat-history",
    target: "menu-hamburguer",
    placement: "right-top",
    content: [
      text("Clique no botão"),
      icon(hamburguerIcon, "menu"),
      text("para acessar o histórico de conversa."),
    ],
    glosa: "CLIQUE COMECAR CONVERSAR",
    offsetY: 75,
  },
];